import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from "./pages/Layout";
import LoginPage from './pages/Auth/login';
import SigninPage from './pages/Signin';
import HomePage from './pages/Home';
import AdminApp from '@app/pages/Admin';
// import UsersPage from './pages/Users';
import UsersPage from './pages/Admin/App/Users';
import RolesPage from './pages/Admin/App/Roles';
import SaldosEmpleado from './pages/Admin/App/SaldosEmpleado';
import MovimientoCompany from './pages/Admin/App/MovimientoCompany';
import ParametrosCompany from './pages/Admin/App/Parametros';
import DefinicionPoliza from './pages/Admin/App/DefinicionPoliza';
import PeriodsPage from './pages/Admin/App/Periodos';
import ConceptoPage from './pages/Admin/App/Concepto';
import ConceptoAcomuladosPage from './pages/Admin/App/Concepto/Acomulados';
import FormulasPage from './pages/Admin/App/Formulas';
import ConceptoAcomuladoPage from './pages/Admin/App/ConceptoAcomulado';
import ConceptoAcomuladoAddPage from './pages/Admin/App/ConceptoAcomulado/AddEdit';
import TipoConceptoPage from './pages/Admin/App/TipoConcepto';
import TipoSaldoPage from './pages/Admin/App/TipoSaldo';
import VariablesFormulaPage from './pages/Admin/App/VariablesFormula';
import FuncionesPage from './pages/Admin/App/Funcion';
import FuncionPage from './pages/Admin/App/Funcion/AddEdit';
import Calculos from './pages/Admin/App/Calculos';
import RegistroPatronal from './pages/Admin/App/RegistroPatronal';
import MovimientosEmpleado from './pages/Admin/App/MovimientosEmpleado';
import MovimientosDiasHoras from './pages/Admin/App/MovimientosDiasHoras';
import ImportarNomina from './pages/Admin/App/ImportarNomina';
import ConfiguracionNominaPage from './pages/Admin/App/ConfiguracionNomina';
import AreasTrabajoPage from './pages/Admin/App/AreasTrabajo';
import NivelesOrganizacionalesPage from './pages/Admin/App/NivelesOrganizacionales/Nivel1';
import NivelesOrganizacionalesN2Page from './pages/Admin/App/NivelesOrganizacionales/Nivel2';
import NivelesOrganizacionalesN3Page from './pages/Admin/App/NivelesOrganizacionales/Nivel3';
import NivelesOrganizacionalesN4Page from './pages/Admin/App/NivelesOrganizacionales/Nivel4';
import NivelesOrganizacionalesN5Page from './pages/Admin/App/NivelesOrganizacionales/Nivel5';
import CierreNomina from './pages/Admin/App/CierreNomina';
import ProcesarNomina from './pages/Admin/App/ProcesarNomina';
import ProcesarNominaGlobal from './pages/Admin/App/ProcesarNominaGlobal';
import RutasPage from './pages/Admin/App/Rutas';
import EmpleadosPage from './pages/Admin/App/Empleados';
import CertificadosPage from './pages/Admin/App/Certificado';
import CompaniasPage from './pages/Admin/App/Companias';
import FormulasGlobalesPage from './pages/Admin/App/FormulasGlobales';
import IntegracionPage from './pages/Admin/App/Integracion';
import MotivosBajaPage from './pages/Admin/App/MotivosBaja';
import NominaCerrada from './pages/Admin/App/NominasCerradas';
import CreditoInfonavit from './pages/Admin/App/CreditoInfonavit';
import TipoIncapacidadPage from './pages/Admin/App/TipoIncapacidad';
import IncapacidadEmpleado from './pages/Admin/App/IncapacidadEmpleado';
import CreditoFonacotPage from './pages/Admin/App/CreditoFonacot';
import DistribucionContable from './pages/Admin/App/DistribucionContable';
import SUAMovimientos from './pages/Admin/App/SUAMovimientos';
import SUAReingresos from './pages/Admin/App/SUAReingresos';
import SUAIncapacidades from './pages/Admin/App/SUAIncapacidades';
import SUACreditoInfonavit from './pages/Admin/App/SUACreditoInfonavit';
import SUAMovimientosAfiliatorios from './pages/Admin/App/SUAMovimientosAfiliatorios';
import HistoricoNomina from './pages/Admin/App/HistoricoNomina';
import TimbrarNomina from './pages/Admin/App/TimbrarNomina';
import TimbradoPeriodo from './pages/Admin/App/TimbradoPeriodo';
import DesafectarNomina from './pages/Admin/App/DesafectarNomina';
import IDSEReingresos from './pages/Admin/App/IDSEReingresos';
import IDSEBajas from './pages/Admin/App/IDSEBajas';
import IDSECambioSalario from './pages/Admin/App/IDSECambioSalario';
import GenerarPoliza from './pages/Admin/App/GenerarPoliza';
import TipoLiquidacionPage from './pages/Admin/App/TipoLiquidacion';
import Finiquitos from './pages/Admin/App/Finiquitos';
import DefinicionFormatoBancoPage from './pages/Admin/App/DefinicionFormatoBancos';
import DistribucionBancaria from './pages/Admin/App/DistribucionBancaria';
import DistribucionEfectivo from './pages/Admin/App/DistribucionEfectivo';
import ResumenNominaPDF from './pages/Admin/App/ResumenNominaPDF';
import ConstanciaRetencionesPDF from './pages/Admin/App/ConstanciaRetencionesPDF';
import TimeLeave from './pages/Admin/App/TimeLeave';
import TimeSheet from './pages/Admin/App/TimeSheet';
import Schedule from './pages/Admin/App/Horarios';
import EstacionesChequeoPage from './pages/Admin/App/EstacionChequeo';
import RolTurnoPage from './pages/Admin/App/RolTurno';
import MotivosPage from './pages/Admin/App/Motivos';
import DefinicionAutorizacionPage from './pages/Admin/App/DefinicionAutorizacionPage';
import EnviarRecibosEmailPage from './pages/Admin/App/EnvioRecibos';
import ConfiguracionEmailPage from './pages/Admin/App/ConfiguracionEmail';
import DiasFestivosPage from './pages/Admin/App/DiasFestivos';
import CalculoIntegradosPage from './pages/Admin/App/CalculoIntegrados';
import OdooLeaveTypePage from './pages/Admin/App/OdooLeaveType';
import ChequeoEntradasPage from './pages/Admin/App/ChequeoEmpleado';
import GeneracionChecadasPage from './pages/Admin/App/GeneracionChecadas';
import CheckInsByDayPage from './pages/Admin/App/ChequeoDia';
import ProcesarPreNomina from './pages/Admin/App/PreNominaIndividual';
import ProcesarPreNominaGlobal from './pages/Admin/App/PreNominaGlobal';
import CierrePreNomina from './pages/Admin/App/CierrePreNomina';
import DesafectarPreNomina from './pages/Admin/App/DesafectarPreNomina';
import EliminacionChecadasPage from './pages/Admin/App/BorrarChecadas';
import ConfiguracionChecadasPage from './pages/Admin/App/ConfiguracionChecadas';
import AutorizacionesGlobalesPage from './pages/Admin/App/AutorizacionesGlobales';
import ReciboPrenominaPage from './pages/Admin/App/ReciboPrenomina';
import PrenominaPeriodoPage from './pages/Admin/App/PrenominaPeriodo';
import ReporteTiempoExtraPage from './pages/Admin/App/ReporteTiempoExtra';
import ReporteTiempoOrdinarioPage from './pages/Admin/App/ReporteTiempoOrdinario';
import CalculoAguinaldo from './pages/Admin/App/CalculoAguinaldo';
import AplicacionAguinaldo from './pages/Admin/App/AplicacionAguinaldo';
import CalculoVariable from './pages/Admin/App/CalculoVariable';
import CorreccionAcumuladosMensual from './pages/Admin/App/CorreccionAcumuladosMensual';
import CorreccionAcumuladosAnuales from './pages/Admin/App/CorreccionAcumuladosAnuales';
import ImportarAcumulados from './pages/Admin/App/ImportarAcumulados';
import ConfiguracionAplicacion from './pages/Admin/App/ConfiguracionAplicacion';
import PlantillaEmailPage from './pages/Admin/App/PlantillaEmail';
import AcumuladosPeriodoPage from './pages/Admin/App/AcumuladosPeriodo';
import TimbradosPeriodoPage from './pages/Admin/App/TimbradosPeriodo';
import OdooCuentaView from './pages/Admin/App/OdooCuenta';
import SolicitudDocumentosPage from './pages/Admin/App/SolicitudDocumentos';

import { HomeOutlined, UserOutlined, } from '@ant-design/icons';
import SupervisorsPage from './pages/Admin/App/DisenoAsistensia';

function PrivateRoute({ children, ...rest }) {
    let navigate = useNavigate();
    const isLoggedIn = useSelector((state) => state.Auth.isLoggedIn);

    if (!isLoggedIn) {
        return navigate("/signin");
    }
    return (
        <Route {...rest} render={({ location }) => children} />
    );
}

const menuGlobal = [
    {
        key: 'home',
        icon: <HomeOutlined />,
        label: 'Inicio',
    },
    {
        key: 'users',
        icon: <UserOutlined />,
        label: 'Usuarios',
    },
];
const NoMatch = () => <>No match!</>
export default function RoutesApp() {
    return (
        //   <HashRouter>
        <Routes>
            <Route path="/home" element={<AdminApp />}>
                <Route index element={<HomePage />} />
            </Route>
            <Route path="/admin" element={<Navigate to="/home" replace />} />
            <Route path="/app" element={<AdminApp />}>
                <Route path="home" element={<HomePage />} />
                <Route path="users" element={<UsersPage />} />
                <Route path="*" element={<NoMatch />} />
            </Route>
            <Route path="/configuracion" element={<AdminApp />}>
                <Route path="configuracion_email" element={<ConfiguracionEmailPage />} />,
                <Route path='configuracion_aplicacion' element={<ConfiguracionAplicacion />} />  
                <Route path='plantilla_email' element={<PlantillaEmailPage />} />,
                <Route path="configuracion_nomina" element={<ConfiguracionNominaPage />} />,
                <Route path="users" element={<UsersPage />} />,
                <Route path="roles" element={<RolesPage />} />,
                <Route path="parametros" element={<ParametrosCompany />} />,
                <Route path="tipo_concepto" element={<TipoConceptoPage />} />,
                <Route path="tipo_saldo" element={<TipoSaldoPage />} />,
                <Route path="concepto" element={<ConceptoPage />} />,
                <Route path="formulas/:conceptId" element={<FormulasPage />} />,
                <Route path="concepto_acomulados/:conceptId" element={<ConceptoAcomuladosPage />} />,
                <Route path="concepto_acomulado" element={<ConceptoAcomuladoPage />} />,
                <Route path="concepto_acomulado/:id" element={<ConceptoAcomuladoAddPage />} />,
                <Route path="periodos" element={<PeriodsPage />} />,
                <Route path="calculos" element={<Calculos />} />,
                <Route path='formulas_globales' element={<FormulasGlobalesPage />} />,
                <Route path="variable_formula" element={<VariablesFormulaPage />} />,
                <Route path="funciones" element={<FuncionesPage />} />,
                <Route path="funcion/:id" element={<FuncionPage />} />,
                <Route path="definicion_polizas" element={<DefinicionPoliza />} />,
                <Route path='definicion_formato_banco' element={<DefinicionFormatoBancoPage />} />,
                <Route path="timeleave" element={<Navigate to="/recursos_humanos/tiempo_personal" replace />} />,
                <Route path="timesheet" element={<Navigate to="/asistencia/timesheet" replace />} />,
                <Route path="horarios" element={<Schedule />} />,
                <Route path='configuracion_checadas' element={<ConfiguracionChecadasPage />} />,

                <Route path='certificados' element={<CertificadosPage />} />,
                <Route path='companias' element={<CompaniasPage />} />,
                <Route path='registro-patronal' element={<RegistroPatronal />} />,
                <Route path='areas-trabajo' element={<AreasTrabajoPage />} />,
                <Route path='rutas' element={<RutasPage />} />,
                <Route path='integrados' element={<IntegracionPage />} />,
                <Route path='niveles-organizacionales' element={<NivelesOrganizacionalesPage />} />,
                <Route path='niveles-organizacionales2' element={<NivelesOrganizacionalesN2Page />} />,
                <Route path='niveles-organizacionales3' element={<NivelesOrganizacionalesN3Page />} />,
                <Route path='niveles-organizacionales4' element={<NivelesOrganizacionalesN4Page />} />,
                <Route path='niveles-organizacionales5' element={<NivelesOrganizacionalesN5Page />} />,
                <Route path='motivos_baja' element={<MotivosBajaPage />} />,
                <Route path='tipos_liquidacion' element={<TipoLiquidacionPage />} />,
                <Route path="estacion_chequeo" element={<EstacionesChequeoPage />} />,
                <Route path="motivos" element={<MotivosPage />} />,
                <Route path='tipos_ausencia' element={<OdooLeaveTypePage/>}/>,
                <Route path='tipo_incapacidad' element={<TipoIncapacidadPage />} />,
                <Route path='cuentas_contables' element={<OdooCuentaView/>}/>,

                <Route path="supervisores" element={<SupervisorsPage />} />,
                <Route path="dias_festivos" element={<DiasFestivosPage />} />,
                <Route path="*" element={<NoMatch />} />
            </Route>

            <Route path="/nomina" element={<AdminApp />}>
                <Route path='historico_nomina_empleado' element={<HistoricoNomina />} />,
                <Route path='acumulados_del_periodo' element={<AcumuladosPeriodoPage />} />,
                <Route path='timbrados_del_periodo' element={<TimbradosPeriodoPage />} />,
                <Route path='correcion_acumulado_mensual' element={<CorreccionAcumuladosMensual />} />,
                <Route path='correcion_acumulado_anual' element={<CorreccionAcumuladosAnuales />} />,
                <Route path='nomina_cerrada' element={<NominaCerrada />} />,
                <Route path='generar_poliza' element={<GenerarPoliza />} />,

                <Route path="saldos-empleado" element={<SaldosEmpleado />} />,
                <Route path="movimientos-company" element={<MovimientoCompany />} />,
                <Route path='movimientos-empleado' element={<MovimientosEmpleado />} />,
                <Route path='movimientos-dias-horas' element={<MovimientosDiasHoras />} />,

                <Route path="procesar_nomina" element={<ProcesarNomina />} />,
                <Route path="procesar_nomina_global" element={<ProcesarNominaGlobal />} />,
                <Route path="cierre_nomina" element={<CierreNomina />} />,
                <Route path='timbrar_nomina' element={<TimbrarNomina />} />,
                <Route path='timbrar_periodo' element={<TimbradoPeriodo />} />,
                <Route path='desafectar_nomina' element={<DesafectarNomina />} />,
                <Route path='distribucion_contable' element={<DistribucionContable />} />,

                <Route path='finiquitos' element={<Finiquitos />} />,

                <Route path='distribucion_bancaria' element={<DistribucionBancaria />} />,
                {/* <Route path="envio_recibos_correo" element={<EnviarRecibosEmailPage />} />, */}
                <Route path='importacion_acumulados' element={<ImportarAcumulados />} />,
                <Route path='importacion_nomina' element={<ImportarNomina />} />,

                <Route path='calculo_aguinaldo' element={<CalculoAguinaldo />} />,
                <Route path='aplicacion_aguinaldo' element={<AplicacionAguinaldo />} />,

                <Route path='resumen_nomina_pdf' element={<ResumenNominaPDF />} />,
                <Route path='constancia_retenciones_isr' element={<ConstanciaRetencionesPDF />} />,
                <Route path='distribucion_efectivo' element={<DistribucionEfectivo />} />,
                <Route path="*" element={<NoMatch />} />
            </Route>
            <Route path="/recursos_humanos" element={<AdminApp />}>
                <Route path='empleados' element={<EmpleadosPage />} />,
                <Route path='credito_infonavit' element={<CreditoInfonavit />} />,
                <Route path='credito_fonacot' element={<CreditoFonacotPage />} />,
                <Route path='tipo_incapacidad' element={<Navigate to="/configuracion/tipo_incapacidad" replace />} />,
                <Route path='tiempo_personal' element={<TimeLeave />} />,
                <Route path='incapacidad_empleado' element={<IncapacidadEmpleado />} />,

                <Route path='sua_movimientos' element={<SUAMovimientos />} />,
                <Route path='sua_reingresos' element={<SUAReingresos />} />,
                <Route path='sua_incapacidades' element={<SUAIncapacidades />} />,
                <Route path='sua_credito_infonavit' element={<SUACreditoInfonavit />} />,
                <Route path='sua_datos_afiltrados' element={<SUAMovimientosAfiliatorios />} />,
                <Route path='idse_reingresos' element={<IDSEReingresos />} />,
                <Route path='idse_bajas' element={<IDSEBajas />} />,
                <Route path='idse_cambios_salario' element={<IDSECambioSalario />} />,

                <Route path="calculo_integrados" element={<CalculoIntegradosPage />} />,
                <Route path='calculo_variable' element={<CalculoVariable />} />,
                <Route path="*" element={<NoMatch />} />
            </Route>
            <Route path="/asistencia" element={<AdminApp />}>
                <Route path='tiempo_personal' element={<Navigate to="/recursos_humanos/tiempo_personal" replace />} />,
                <Route path='timesheet' element={<TimeSheet />} />,
                <Route path="rol_turno" element={<RolTurnoPage />} />,
                <Route path='autorizaciones_por_empleado' element={<DefinicionAutorizacionPage/>}/>,
                <Route path='autorizaciones_globales' element={<AutorizacionesGlobalesPage />} />,
                <Route path="chequeo_entradas" element={<ChequeoEntradasPage />} />,
                <Route path="generacion_checadas" element={<GeneracionChecadasPage />} />,
                <Route path='borrar_checadas' element={<EliminacionChecadasPage />} />,
                <Route path='chequeo_dia' element={<CheckInsByDayPage />} />,
                <Route path='recibo_prenomina' element={<ReciboPrenominaPage />} />,
                <Route path='prenomina_periodo' element={<PrenominaPeriodoPage />} />,
                <Route path='reporte_tiempo_extra' element={<ReporteTiempoExtraPage />} />,
                <Route path='reporte_tiempo_ordinario' element={<ReporteTiempoOrdinarioPage />} />,
                <Route path='procesar_pre_nomina' element={<ProcesarPreNomina />} />,
                <Route path='procesar_pre_nomina_global' element={<ProcesarPreNominaGlobal />} />,
                <Route path='cierre_pre_nomina' element={<CierrePreNomina />} />,
                <Route path='desafectar_pre_nomina' element={<DesafectarPreNomina />} />,
                <Route path='solicitud_documentos' element={<SolicitudDocumentosPage />} />,
                <Route path="*" element={<NoMatch />} />
            </Route>
            <Route path="*" element={<NoMatch />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<SigninPage />} />
            <Route path="/signin" element={<SigninPage />} />
        </Routes>
        // </HashRouter>
    );
}

